export const initial = {
  currentPage: 1,
  itemsPerPage: 10,
  items: [],
  sort: {
    key: 'createDate',
    order: -1,
  },
  filter: {
    externalId: '',
    id: '',
    appId: '',
    appName: '',
    locale: '',
    platform: '',
    manufacturer: '',
    model: '',
    idfa: '',
    googleAdId: '',
    ip: '',
    country: '',
    city: '',
    width: '',
    height: '',
    androidPackageId: '',
    osVersion: '',
  },
};



/** WEBPACK FOOTER **
 ** ./js/redux/state/users.state.js
 **/